module.exports = __webpack_public_path__ + "static/so-3-sq-d71a43dd8ca123e33b50ae2607986a16.png";